import { getAdminStores, AdminStore } from 'services/api/admin';
import { useRequest } from 'ahooks';
import { groupBy } from '@knowledge/common/helpers/store';

/**
 * 当用户进入知识配置的页面的时候需要店铺数据进行一下缓存，避免多次调用接口
 * 在 src/views/Knowledge/Detail/index.tsx 中需要清空缓存
 */

let stores: AdminStore[] = [];
let groupByStores: Record<string, AdminStore[]> = {};

export function getStores(): Promise<AdminStore[]> {
  return new Promise<AdminStore[]>((resolve, reject) => {
    if (stores.length) {
      return resolve(stores);
    }
    getAdminStores({
      page: 1,
      pageSize: 99999,
    })
      .then((res) => {
        stores = res.data.data.stores;
        resolve(stores);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getGroupByStores(): Promise<Record<string, AdminStore[]>> {
  return new Promise((resolve, reject) => {
    if (Object.keys(groupByStores).length > 0) {
      return resolve(groupByStores);
    } else {
      getStores()
        .then((res) => {
          resolve(groupBy(res));
        })
        .catch((err) => {
          reject(err);
        });
    }
  });
}

export const useStores = () => {
  const { loading, data } = useRequest(getStores);
  return {
    loading,
    data,
  };
};

/**
 * how to use
 * useUnmount(() => {
 *   detachCache()
 * })
 */
export const detachCache = () => {
  stores = [];
  groupByStores = {};
};
